import { render, staticRenderFns } from "./selectChannel.vue?vue&type=template&id=6767287b&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=6767287b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6767287b",
  null
  
)

export default component.exports